import numeral from "numeral";

// Calculate the precision syntax for Numeral
export const calculatePrecisionFormat = (precision = 3) => {
  let zeros = [];
  let limit = precision - 2;

  for (var i = 0; i < limit; i++) {
    zeros.push("0");
  }

  let zerosString = zeros.join("");

  let string = `0,0.00[${zerosString}]`;

  return string;
};

// Debounce
export const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Throttle
export const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

// Get base64
export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// Find Market Pairs
export const currencyPairs = (currency, markets) => {
  let pairs = [];

  markets.map((m) => {
    let matchesAsk = m.ask_unit === currency.toLowerCase();
    let matchesBid = m.bid_unit === currency.toLowerCase();

    if (matchesAsk) {
      return pairs.push(m.bid_unit);
    }

    if (matchesBid) {
      return pairs.push(m.ask_unit);
    }
  });

  return pairs;
};

// Calculate 24H Change
export const calculateChange24 = (open, last) => {
  let o = numeral(open);
  let l = numeral(last);

  let diff = l.subtract(o.value());
  let div = diff.divide(o.value());
  let change = div.multiply(100);

  return change.value();
};

// Calculate Countdown
export const calculateCountdown = (now, future) => {
  let distance = future.diff(now);

  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  hours = numeral(hours).format("00");
  minutes = numeral(minutes).format("00");
  seconds = numeral(seconds).format("00");

  return `${hours}:${minutes}:${seconds}`;
};
